module.exports = __webpack_public_path__ + "static/media/edit-blue-bg-icon.aed87a4c.svg";